import { TAddOnItem } from "@/components/Checkout/utils";
import { ADDON_REF_ID_MAPPING } from "@/data/plans";

interface GetAddOnsDetailParams {
  ownedAddOnItemList: TAddOnItem[];
  customAiProfile: number | undefined;
  instantProfiles: number | undefined;
}

/**
 * Gets the list of add-ons details to display
 * Only shows custom/instant profiles if user has the profiles add-on
 */
export function getAddOnsDetail({
  ownedAddOnItemList,
  customAiProfile,
  instantProfiles,
}: GetAddOnsDetailParams): string[] {
  const addOnsDetail: string[] = [];

  // Check if user has profiles add-on
  const hasProfilesAddOn = ownedAddOnItemList.some(
    (addOn) => addOn.productRefId === ADDON_REF_ID_MAPPING.profiles,
  );

  const hasGalleryAddOn = ownedAddOnItemList.some(
    (addOn) => addOn.productRefId === ADDON_REF_ID_MAPPING.gallery_unlimited,
  );

  if (hasProfilesAddOn) {
    // Only show profile details if user has the profiles add-on
    if (customAiProfile && customAiProfile > 0) {
      addOnsDetail.push(`Custom profiles x ${customAiProfile}`);
    }

    if (instantProfiles && instantProfiles > 0) {
      addOnsDetail.push(`Instant profiles x ${instantProfiles}`);
    }
  }

  if (hasGalleryAddOn) {
    addOnsDetail.push("Gallery Unlimited");
  }

  return addOnsDetail;
}
